module.exports = __webpack_public_path__ + "static/media/dialog_queen_mea_01.f760c1ec.png";